import { createSelector } from '@reduxjs/toolkit';
import { selectSecurity, selectSecurityPrice } from '../../store/selectors';

export const selectParameters = createSelector(selectSecurityPrice, (listState) => listState.parameters);
export const selectSecurityPriceStatistics = createSelector(selectSecurityPrice, (listState) => listState.securityPriceStatistics);
export const selectSecurityPriceChart = createSelector(selectSecurityPrice, (listState) => listState.dailySecurityPricesChart);
export const selectSecurityPrices = createSelector(selectSecurityPrice, (listState) => listState.securityPrices);
export const selectSecurityCommon = createSelector(selectSecurity, (securityState) => securityState.common);
